import { useQuery } from '@tanstack/react-query';
import { useHistory } from 'react-router-dom';
import Spinner from '../../components/layout/Spinner';
import BreadCrumb from '../../components/template/BreadCrumb';
import Header from '../../components/template/Header';
import api from '../../domain/api';
import {
  inputFields,
  LINK_URL,
  PAGE_SINGLE_TITLE,
  PAGE_TITLE,
} from '../../shared/enums/clients_enum';
import EnhancedClientSingleView from './_components/single-view';

const ViewClient = ({ match }) => {
  const { data: client, isLoading: client_loading } = useQuery({
    queryKey: ['client', match.params.id],
    queryFn: async () => {
      const resp = await api.get(`/clients/${match.params.id}`);
      return resp.data;
    },
  });

  const { data: client_dashboard, isLoading: client_dashboard_loading } =
    useQuery({
      queryKey: ['client_dashboard', match.params.id],
      queryFn: async () => {
        const resp = await api.get(`/clients/dashboard/${match.params.id}`);
        return resp.data;
      },
    });

  const history = useHistory();

  const handleEdit = () => {
    history.push(`/clients/${match.params.id}/edit`);
    console.log('Edit client:', match.params.id);
  };

  const handleBack = () => {
    history.push('/clients');
    console.log('Go back to clients list');
  };

  const handleDashboard = () => {
    history.push(`/clients/${match.params.id}/client-view`);
    console.log('View client dashboard:', match.params.id);
  };

  return (
    <div className='pace-done'>
      <div>
        <Header />
        <BreadCrumb
          title={PAGE_SINGLE_TITLE}
          mainLinkTitle={PAGE_TITLE}
          mainLinkUrl={LINK_URL}
          activeLink='View'
        />

        {!client_loading ? (
          client && (
            <EnhancedClientSingleView
              client={client}
              clientDashboard={client_dashboard}
              inputFields={inputFields}
              onEdit={handleEdit}
              onBack={handleBack}
              onDashboard={handleDashboard}
            />
          )
        ) : (
          <div>
            <Spinner />
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewClient;
